import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import VueCookies from 'vue-cookies'

import common from './modules/common.js'
import auth from './modules/auth.js'
import trackSearch from './modules/trackSearch.js'
import sfxSearch from './modules/sfxSearch.js'
import sfxDownloadLog from './modules/sfxDownloadLog.js'
import player from './modules/player.js'
import user from './modules/user.js'
import favouriteTracks from './modules/favouriteTracks.js'
import cart from './modules/cart.js'
import subscriptions from './modules/subscriptions.js'
import collections from './modules/collections.js'
import licenses from './modules/licenses.js'
import waffle from './modules/waffle.js'

Vue.use(Vuex)
Vue.use(Meta)
Vue.use(VueCookies)

const debug = process.env.NODE_ENV === 'development'

export default new Vuex.Store({
  modules: {
    common,
    auth,
    trackSearch,
    sfxSearch,
    sfxDownloadLog,
    player,
    user,
    favouriteTracks,
    cart,
    subscriptions,
    collections,
    licenses,
    waffle
  },
  strict: debug
})
